import {
  Button, Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import React from "react";
import {useRouter} from "next/router";

export const VerificationFailedModal = ({isFailedOpen, onFailedClose}) => {
  const router = useRouter();

  return (
    <Modal isOpen={isFailedOpen} onClose={onFailedClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Payment Failed</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <p>
           <b>It appears that there was a problem with your payment</b>, please access your verification information in your profile settings and try again.
          </p>
        </ModalBody>

        <ModalFooter>
          <Button
            mr={3}
            onClick={() => {
              onFailedClose();
              router.push({
                pathname: `${window.location.href.split('?')[0]}`,
                query: {
                  tab: 'verification'
                },
              }, undefined, {shallow: true});
            }}
          >
            Got it
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
};
